import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const auth = inject(AuthService);

    const toSignIn = () => {
        const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;

        return router.parseUrl(`sign-in?${redirectURL}`);
    };

    // Somebody who was signed in a moment ago gets the page now. The server is
    // asked in the background, and an expired session sends them to sign in
    // as soon as the answer arrives, instead of making every tap wait for it.
    if (auth.hasSessionHint()) {
        auth.check().subscribe((authenticated) => {
            if (!authenticated && !router.url.startsWith('/sign-in')) {
                router.navigateByUrl(toSignIn());
            }
        });

        return of(true);
    }

    // First visit, or the session was seen to end: nothing to go on, ask first.
    return auth
        .check()
        .pipe(
            switchMap((authenticated) => {
                // If the user is not authenticated...
                if (!authenticated) {
                    // Redirect to the sign-in page with a redirectUrl param
                    const redirectURL =
                        state.url === '/sign-out'
                            ? ''
                            : `redirectURL=${state.url}`;
                    const urlTree = router.parseUrl(`sign-in?${redirectURL}`);

                    return of(urlTree);
                }

                // Allow the access
                return of(true);
            })
        );
};
